export default __webpack_public_path__ + "static/media/App_List_Icon.bea51d32.svg";